'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsLocalParking = function MapsLocalParking(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
  );
};
MapsLocalParking = (0, _pure2.default)(MapsLocalParking);
MapsLocalParking.displayName = 'MapsLocalParking';
MapsLocalParking.muiName = 'SvgIcon';

exports.default = MapsLocalParking;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/maps/local-parking.js
// module id = 2528
// module chunks = 0